module.exports = __webpack_public_path__ + "static/media/blackHeartIcon.b8913346.svg";